var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKenya(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 39.9999C31.0457 39.9999 40 31.0456 40 19.9999C40 8.95424 31.0457 -6.10352e-05 20 -6.10352e-05C8.9543 -6.10352e-05 0 8.95424 0 19.9999C0 31.0456 8.9543 39.9999 20 39.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 -6.10352e-05C12.0707 -6.10352e-05 5.2195 4.61439 1.9845 11.3043H38.0153C34.7804 4.61439 27.9291 -6.10352e-05 20 -6.10352e-05V-6.10352e-05Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 40C12.0707 40 5.2195 35.3855 1.9845 28.6956H38.0153C34.7804 35.3855 27.9291 40 20 40V40Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0555 13.9129H0.944453C0.331797 15.8324 0 17.8773 0 19.9999C0 22.1224 0.331797 24.1674 0.944453 26.0868H39.0555C39.6682 24.1674 40 22.1224 40 19.9999C40 17.8773 39.6682 15.8324 39.0555 13.9129Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2277 9.24219L23.8592 8.14899L19.9999 16.8873L16.1407 8.14899L13.7722 9.24219L18.5635 19.9999L13.7722 30.7577L16.1407 31.8509L19.9999 23.1125L23.8592 31.8509L26.2277 30.7577L21.4364 19.9999L26.2277 9.24219Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6086 10.2725C20.6917 9.27118 19.9999 8.69556 19.9999 8.69556C19.9999 8.69556 19.3081 9.2711 18.3912 10.2725V29.7272C19.3081 30.7287 19.9999 31.3043 19.9999 31.3043C19.9999 31.3043 20.6917 30.7288 21.6086 29.7273V10.2725Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6521 14.0032V25.9963C16.621 27.7131 17.8069 29.1203 18.6956 30.0532V9.94629C17.8069 10.8792 16.6209 12.2864 15.6521 14.0032V14.0032Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3477 14.0032C23.3787 12.2864 22.1929 10.8792 21.3042 9.94629V30.0532C22.1929 29.1203 23.3787 27.7131 24.3477 25.9963V14.0032Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3478 14.0033V25.9964C25.3286 24.2582 26.0869 22.2028 26.0869 19.9999C26.0869 17.797 25.3286 15.7416 24.3478 14.0033Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6521 14.0033V25.9964C14.6712 24.2582 13.913 22.2028 13.913 19.9999C13.913 17.797 14.6712 15.7416 15.6521 14.0033Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKenya);
export default __webpack_public_path__ + "static/media/kenya.7fa7944b6789d505ce07a6a60d2f71eb.svg";
export { ForwardRef as ReactComponent };